const C = {
  pink: "#F7A1C4", mint: "#9ED9C3", yellow: "#FFD966",
  blue: "#9CCBFF", lilac: "#D7B7F6", ink: "#1F1F1F", cream: "#FFF8F1",
  pinkSoft: "#FDE8F0", mintSoft: "#E6F5EE", yellowSoft: "#FFF7DC",
  blueSoft: "#E4F0FF", lilacSoft: "#F0E5FC",
};
const heading = "'Baloo 2', cursive, sans-serif";
const body = "'Nunito', sans-serif";

const IMG = {
  logo: "/images/logo.webp",
  dottie: "/images/characters/dottie.webp",
};

export default function BookingSuccess() {
  return (
    <div style={{ background: C.cream, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <link href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Nunito:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      <style>{`
        @keyframes idleWobble {
          0%, 100% { transform: rotate(0deg) scaleX(1) scaleY(1); }
          20% { transform: rotate(-3deg) scaleX(1.02) scaleY(0.98); }
          50% { transform: rotate(3deg) scaleX(0.98) scaleY(1.02); }
          80% { transform: rotate(-2deg) scaleX(1.01) scaleY(0.99); }
        }
        @keyframes rainbowSlide {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
      `}</style>
      <div style={{ maxWidth: 480, width: "100%", textAlign: "center" }}>
        <img src={IMG.logo} alt="The Funky Bunch" style={{ width: 160, margin: "0 auto 24px", display: "block" }} />
        <div style={{
          width: 120, height: 120, margin: "0 auto 24px",
          animation: "idleWobble 1.8s ease-in-out infinite",
          transformOrigin: "center bottom",
        }}>
          <img src={IMG.dottie} alt="Dottie" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
        </div>
        <h1 style={{
          fontFamily: heading, fontSize: 32, fontWeight: 800,
          background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac}, ${C.pink})`,
          backgroundSize: "200% 100%",
          WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          backgroundClip: "text", animation: "rainbowSlide 4s linear infinite",
          marginBottom: 12,
        }}>
          Booking Confirmed!
        </h1>
        <p style={{
          fontFamily: body, fontSize: 16, color: C.ink + "aa",
          lineHeight: 1.7, marginBottom: 8,
        }}>
          Thank you for booking with The Funky Bunch! We can't wait to see you on the dancefloor.
        </p>
        <p style={{
          fontFamily: body, fontSize: 14, color: C.ink + "77",
          lineHeight: 1.6, marginBottom: 32,
        }}>
          You will receive a confirmation email shortly with all your booking details.
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={() => { window.location.hash = "home"; }} style={{
            background: C.pink, color: "#fff", border: "none",
            padding: "14px 28px", borderRadius: 50,
            fontFamily: heading, fontWeight: 700, fontSize: 15, cursor: "pointer",
          }}>Back to Home</button>
          <button onClick={() => { window.location.hash = "classes"; }} style={{
            background: "transparent", color: C.ink, border: `2px solid ${C.mint}`,
            padding: "14px 28px", borderRadius: 50,
            fontFamily: heading, fontWeight: 700, fontSize: 15, cursor: "pointer",
          }}>Book Another Class</button>
        </div>
      </div>
    </div>
  );
}
